import { useCallback, useEffect, useState } from "react";
import Offcanvas from "react-bootstrap/Offcanvas";
import Button from "react-bootstrap/Button";
import { useDispatch } from "react-redux";
import {
  organisationInvitesListAction,
  organisationInviteDecisionAction,
  organisationLeaveAction,
} from "../../Redux/Action/OrganisationAction";
import { useSelector } from "react-redux";
import ConfirmModal from "../../modals/ConfirmModal";
import { schoolDetailAction } from "../../Redux/Action/AuthAction";

const formatDisplayDate = (value) => {
  if (!value) return "-";

  return new Date(value).toLocaleDateString("en-GB", {
    day: "2-digit",
    month: "short",
    year: "numeric",
  });
};

export default function SchoolInvitesOffcanvas({ show, handleClose }) {
  const dispatch = useDispatch();
  const [invites, setInvites] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState("");
  const [actionLoadingId, setActionLoadingId] = useState("");
  const [isModalOpen, setModalOpen] = useState(false);
  const [selectedType, setSelectedType] = useState("");

  const schoolDetail = useSelector((state) => state?.authSlice?.schoolDetail);
  const isInGroup = !!schoolDetail?.organisationGroupId;

  const fetchInvites = useCallback(async () => {
    setIsLoading(true);
    setError("");

    const response = await dispatch(
      organisationInvitesListAction({ page: 0, limit: 10, search: "" })
    );

    if (response?.payload?.data?.invites) {
      setInvites(response.payload.data.invites);
    } else {
      setInvites([]);
      setError(response?.payload?.message || "Unable to load invites right now.");
    }

    setIsLoading(false);
  }, [dispatch]);

  useEffect(() => {
    if (show) {
      fetchInvites();
    }
  }, [fetchInvites, show]);

  const handleInviteAction = async (inviteId, inviteStatus) => {
    setActionLoadingId(inviteId);
    setError("");

    const response = await dispatch(
      organisationInviteDecisionAction({ inviteId, inviteStatus })
    );

    console.log("organisationInviteDecisionAction response", response?.payload);

    if (response?.error) {
      setError(response?.payload?.message || "Unable to update invite right now.");
    } else {
      fetchInvites();
    }

    setActionLoadingId("");
  };

  const handleLeaveGroup = () => {
    setModalOpen(true);
    setSelectedType("leaveOrganisationGroup");
  };

  const handleConfirmClose = () => {
    setModalOpen(false);
  };

  return (
    <Offcanvas
      show={show}
      onHide={handleClose}
      placement="end"
      className="school-invites-offcanvas"
    >
      <Offcanvas.Header closeButton>
        <Offcanvas.Title className="school-invites-title">Group Invites</Offcanvas.Title>
      </Offcanvas.Header>
      <Offcanvas.Body>
        <div className="school-invites-body">
          <p className="school-invites-subtitle">
            Review organisation group invitations for this school.
          </p>

          {error && <div className="error text-danger mb-3">{error}</div>}

          {isLoading ? (
            <div className="cmn-card-color p-3 text-center">Loading invites...</div>
          ) : invites.length === 0 ? (
            <div className="cmn-card-color p-3 text-center">No invites found.</div>
          ) : (
            invites.map((invite) => {
              const inviteId = invite?._id;
              const isPending = invite?.inviteStatus === "INVITED";
              const inviterName =
                `${invite?.invitedBy?.firstName || ""} ${
                  invite?.invitedBy?.surName || ""
                }`.trim() || "-";

              return (
                <div key={inviteId} className="cmn-card-color school-invite-card">
                  <div className="school-invite-card-head">
                    <div>
                      <h4>{invite?.schoolName || invite?.schoolId?.schoolName || "-"}</h4>
                      <p>{invite?.schoolEmail || invite?.schoolId?.schoolEmail || "-"}</p>
                    </div>
                    <span
                      className={`school-invite-status ${
                        isPending ? "school-invite-status-pending" : "school-invite-status-updated"
                      }`}
                    >
                      {invite?.inviteStatus || "-"}
                    </span>
                  </div>

                  <div className="school-invite-meta">
                    <p>
                      <strong>Organisation Group:</strong>{" "}
                      {invite?.organisationGroupId?.name || "-"}
                    </p>
                    <p>
                      <strong>Invited By:</strong> {inviterName}
                    </p>
                    <p>
                      <strong>Invited On:</strong> {formatDisplayDate(invite?.createdAt)}
                    </p>
                  </div>

                  <div className="school-invite-actions">
                    <Button
                      variant="primary"
                      className="modal-f-btn"
                      disabled={!isPending || actionLoadingId === inviteId}
                      onClick={() => handleInviteAction(inviteId, "ACCEPTED")}
                    >
                      {actionLoadingId === inviteId ? "Updating..." : "Accept"}
                    </Button>
                    
                  </div>
                </div>
              );
            })
          )}
        </div>

        {isInGroup && (
          <div className="mt-auto pt-4 border-top">
            <h4 className="school-invites-title mb-3">Current Organisation group</h4>
            <div className="cmn-card-color p-3 mb-3">
              <p className="mb-1"><strong>Group:</strong> {schoolDetail?.organisationGroupId?.name}</p>
              <p className="mb-0 small text-muted">You are currently a member of this organisation group.</p>
            </div>
            <button
              onClick={handleLeaveGroup}
              className="cmn-pink w-100 mt-2"
              style={{ background: "#ff4d4f" }}
            >
              Leave Organisation Group
            </button>
          </div>
        )}
      </Offcanvas.Body>
      <ConfirmModal
        isModalOpen={isModalOpen}
        handleConfirmClose={handleConfirmClose}
        selectedType={selectedType}
      />
    </Offcanvas>
  );
}
